import { filmstripExpandedAtom, showingFilmstripExpanderAtom } from "@/store/ui-views-state"
import { showingExpressFilmstripTooltipAtom } from "@/store/app-state"
import { useTranslation } from "react-i18next"
import { Icon } from "@/components/icons/Icon"
import { analytics } from "@/telemetry/amplitude"
import { FloatingTooltip } from "@/components/ui/FloatingTooltip"
import { useAtom, useAtomValue } from "jotai"
import clsx from "clsx"
import { Filmstrip } from "./Filmstrip"
import { photosViewAtom } from "@/store/photo/photos-view-state"

export const FilmstripGroup = () => {
	const { t } = useTranslation("components")
	const [isExpanded, setIsExpanded] = useAtom(filmstripExpandedAtom)
	const [isControlShown, setIsControlShown] = useAtom(showingFilmstripExpanderAtom)
	const [previewState] = useAtom(photosViewAtom)
	const showExpressFilmstripTooltip = useAtomValue(showingExpressFilmstripTooltipAtom)

	const toggleExpanded = (target: EventTarget) => {
		analytics.trackEvent(
			{ label: "filmstrip_toggle", value: isExpanded ? "close" : "open", type: "click" },
			target,
		)
		if (isExpanded) {
			setIsControlShown(false)
		}
		setIsExpanded(!isExpanded)
	}

	const expandButton = () => {
		return (
			<div
				className={clsx(
					isControlShown ? "visible" : "invisible",
					"absolute top-0 z-10 mt-[-17px] flex w-fit self-center rounded-b-none rounded-t-md bg-base-800 px-4 py-0.5",
				)}
				onClick={(e) => toggleExpanded(e.target)}
			>
				<Icon
					size={14}
					name={isExpanded ? "down" : "up"}
					className="fill-black hover:fill-base-300 dark:fill-white"
				/>
			</div>
		)
	}

	return (
		<div
			className={`relative flex flex-col ${previewState === "grid" ? "" : ""}`}
			onPointerEnter={() => {
				setIsControlShown(true)
			}}
			onPointerLeave={() => {
				setIsControlShown(false)
			}}
		>
			{showExpressFilmstripTooltip && (
				<FloatingTooltip
					open={showExpressFilmstripTooltip}
					side="top"
					sideOffset={-8}
					tooltip={{
						main: t("filmstripGroup.choosePhotoToEdit"),
						index: 1,
						totalCount: 2,
						onboardingKey: "expressSetupTooltipShown",
					}}
				>
					{expandButton()}
				</FloatingTooltip>
			)}

			{!showExpressFilmstripTooltip && expandButton()}

			<div
				className={clsx(!isExpanded && "overflow-hidden")}
				style={isExpanded ? undefined : { height: 0 }}
				aria-hidden={!isExpanded}
			>
				<Filmstrip />
			</div>
		</div>
	)
}
